import store from "../../store";

export class RedirectUtils {
    mountUrl(url) {
        const baseUrl = `${location.protocol}//${location.hostname}${process.env.NODE_ENV === "development" ? `:${Number(location.port) + 1}` : ''}`;
        const params = new URLSearchParams({ token: localStorage.getItem("token") });
        const provider = store.getters["layout/provider"];

        if (provider) params.set("provider", provider);

        return `${baseUrl}${url}?${params.toString()}`;
    }
}

export const redirectUtils = new RedirectUtils()
